export const nonAffiliateSummary = {
  nonAffiliateSummary: "Non-Affiliate Summary",
  search: " Search",
  from: "From",
  to: "To",
  totalUsers: "Total Users",
  totalWinLoss: "Total Win/Loss",
  totalBetAmount: "Total Bet Amount",
  totalTopupAmount: "Total Topup Amount",
  totalWithdrawAmount: "Total Withdraw Amount",
  accountName: "Account Name",
  username: "Username",
  betTotal: "Bet Total",
  settleTotal: "Settle Total",
  topupTotal: "Topup Total",
  withdrawTotal: "Withdraw Total",
  rtbDepositTotal: "RTB Deposit Total",
  rtbWithdrawTotal: "RTB Withdraw Total",
  winloss: "Win/Loss",
  affiliateDetails: "Affiliate Details",
  level: "Level",
  totalDeposit: "Total Deposit",
  betAmount: "Bet Amount",
  settleAmount: "Settel Amount",
  affiliateAmount: "Affiliate Amount",
  withdrawAmount: "Withdraw Amount",
  carry_amount: "carry_amount",
};
